import React, { useState, useEffect } from "react";
import BackBtn from "../../common/backBTN";
import DatePickerPopup from "../../common/DatePickerPopup"; // ✅ same popup component
import NoData from "../../common/NoData";
import { Link } from "react-router-dom";

const WithdrawRecord = ({transactionData}) => {
 
  const [statusFilter, setStatusFilter] = useState("All");
  const [paymentTypeFilter, setPaymentTypeFilter] = useState("All");
  const [dateFilter, setDateFilter] = useState("Today");
  const [selectedDateRange, setSelectedDateRange] = useState({ start: "", end: "" });
  const [showPicker, setShowPicker] = useState(false);

  // === Fetch Withdrawal Records ===
  const safeData = Array.isArray(transactionData) ? transactionData : [];
  

  // === Helper: Check if record is within date filter ===
  const isDateInRange = (date, range) => {
    const today = new Date();
    const txnDate = new Date(date);

    if (range === "Today") return txnDate.toDateString() === today.toDateString();
    if (range === "Yesterday") {
      const y = new Date(today);
      y.setDate(today.getDate() - 1);
      return txnDate.toDateString() === y.toDateString();
    }
    if (range === "7-days") {
      const last7 = new Date(today);
      last7.setDate(today.getDate() - 7);
      return txnDate >= last7 && txnDate <= today;
    }

    if (range === "Custom" && selectedDateRange.start && selectedDateRange.end) {
      const s = new Date(selectedDateRange.start);
      const e = new Date(selectedDateRange.end);
      return txnDate >= s && txnDate <= e;
    }

    return true;
  };

  // === Apply filters ===
// === Apply filters ===
const filteredTransactions = safeData
  // ✅ Step 1: Only include withdrawal transactions
  .filter((txn) => txn.action === "withdraw")
  // ✅ Step 2: Then apply all other filters
  .filter((txn) => {
    const statusMatch =
      statusFilter === "All" ||
      (statusFilter === "Success" && txn.status === "1") ||
      (statusFilter === "Pending" && txn.status === "0") ||
      (statusFilter === "Failed" && txn.status === "2");

    const typeMatch =
      paymentTypeFilter === "All" ||
      (paymentTypeFilter === "E-wallet" && txn.method === "E-wallet") ||
      (paymentTypeFilter === "Bank" && txn.method === "Bank");

    const dateMatch = isDateInRange(txn.created_at, dateFilter);

    return statusMatch && typeMatch && dateMatch;
  });

  // === Totals ===
  const totalAmount = filteredTransactions.reduce(
    (sum, txn) => sum + (parseFloat(txn.amount) || 0),
    0
  );

  // === Date Picker confirm ===
  const handleConfirmDate = (range) => {
    setSelectedDateRange(range);
    setDateFilter("Custom");
    setShowPicker(false);
  };

  const displayDateRange =
    dateFilter === "Custom" && selectedDateRange.start && selectedDateRange.end
      ? `${new Date(selectedDateRange.start).toLocaleDateString("en-GB", {
          month: "2-digit",
          day: "2-digit",
        })} - ${new Date(selectedDateRange.end).toLocaleDateString("en-GB", {
          month: "2-digit",
          day: "2-digit",
        })}`
      : dateFilter === "Today"
      ? "Today"
      : dateFilter === "Yesterday"
      ? "Yesterday"
      : dateFilter === "7-days"
      ? "Last 7 Days"
      : "Select Date";

  return (
    <div id="mc-animate-container" className="v-base v-detail-base fade-enter-done">
      <div className="withdraw-report">
        {/* ==== Header ==== */}
        <div className="mc-header-wrap">
          <div
            id="mc-header"
            className="mc-navbar-blue mc-withdrawReport mc-default-header am-navbar am-navbar-light"
          >
            <BackBtn />
            <div className="am-navbar-title">Withdrawal Record</div>
            <div className="am-navbar-right">
              <div className="to-record">
                <Link to={"/depositRecord"}>
                  <span className="more-icon deposit am-navbar-title">
                    <svg className="am-icon am-icon-deposit_record_b99e1f01 am-icon-md">
                      <use xlinkHref="#deposit_record_b99e1f01" />
                    </svg>
                  </span>
                </Link>
              </div>
            </div>
          </div>
          <div className="am-whitespace am-whitespace-sm mc-whitespace" />
        </div>

        {/* ==== Tabs ==== */}
        <div className="am-tabs am-tabs-top">
          <div role="tablist" className="am-tabs-bar" tabIndex={0}>
            {["Today", "Yesterday", "7-days"].map((label) => (
              <div
                key={label}
                role="tab"
                aria-disabled="false"
                aria-selected={dateFilter === label}
                className={`am-tabs-tab ${
                  dateFilter === label ? "am-tabs-tab-active" : ""
                }`}
                onClick={() => setDateFilter(label)}
              >
                <span className="am-badge">{label}</span>
              </div>
            ))}
          </div>

          {/* ==== Filter Buttons ==== */}
          <div className="am-tabs-content am-tabs-content-no-animated">
            <div role="tabpanel" className="am-tabs-tabpane am-tabs-tabpane-active">
              <div className="am-flexbox am-flexbox-align-middle mc-trans-filter mc-filter">
                <div className="am-flexbox am-flexbox-align-middle mc-trans-filter">
                  <a
                    role="button"
                    className="am-button am-button-ghost am-button-small am-button-inline"
                    onClick={() => setStatusFilter("All")}
                  >
                    <span>{statusFilter}</span>
                  </a>

                  <div className="flex-shrink1 filter-time-btn">
                    <a
                      role="button"
                      className="am-button am-button-ghost am-button-small am-button-inline am-button-icon"
                      onClick={() => setShowPicker(true)}
                      style={{ flex: "0 0 50%" }}
                    >
                      <svg
                        className="am-icon am-icon-calendar_c4db3b67 am-icon-xxs"
                        aria-hidden="true"
                      >
                        <use xlinkHref="#calendar_c4db3b67" />
                      </svg>
                      <span>{displayDateRange}</span>
                    </a>
                  </div>
                </div>
              </div>

              {/* ==== Records List ==== */}
              <div className="mc-trans-record-container">
                <div className="withdraw-detail-list records-list-root">
                  {filteredTransactions.length === 0 ? (
                    <NoData/>
                  ) : (
                    filteredTransactions.map((txn, index) => (
                      <div key={index} className="records-root">
                        <div className="am-card">
                          <div className="am-card-body">
                            <div className="card-header">
                              <div className="wr-card-header EW">
                                <span className="card-title">{txn.payment_method?.name || "Unknown"}</span>
                              </div>
                              <div className="card-time">
                                <span>
                                  {new Date(txn.created_at)
                                    .toISOString()
                                    .slice(0, 19)
                                    .replace("T", " ")}
                                </span>
                              </div>
                            </div>

                            <div className="card-body width">
                              <div className="card-item">
                                <div className="card-title">Withdrawal Type</div>
                                <div className="card-num">E-Wallet</div>
                              </div>
                              <div className="card-item">
                                <div className="card-title">Withdrawal number</div>
                                <div className="card-num">{txn.method_number || txn.provider}</div>
                              </div>
                              <div className="card-item">
                                <div className="card-title">Remarks</div>
                                <div className="card-num remark"> {txn.key === 1
                                    ? "Withdrawal success"
                                    : txn.key === 0
                                    ? "Pending"
                                    : "Failed"}</div>
                              </div>
                            </div>

                            <div className="card-footer">
                              <div className="card-item">
                                <div className="card-title">Amount</div>
                                <div className="card-num amount">
                                  {parseFloat(txn.amount).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                  })}
                                </div>
                              </div>
                              <div className="card-item status">
                                <div className="card-title">Status</div>
                                <div
                                  className={`card-num ${
                                    txn.key === 1
                                      ? "color4"
                                      : txn.key === 0
                                      ? "color3"
                                      : "color1"
                                  }`}
                                >
                                  {txn.key === 1
                                    ? "Withdrawal success"
                                    : txn.key === 0
                                    ? "Pending"
                                    : "Failed"}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                  {filteredTransactions.length > 0 && (
                    <div className="baseLine">
                      <hr className="hrLine one" />
                      <span>No more records</span>
                      <hr className="hrLine two" />
                    </div>
                  )}
                </div>
              </div>

              {/* ==== Footer ==== */}
              <div className="records-footer show">
                <span>Total:</span>
                <span>
                  {totalAmount.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                  })}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* ==== Popup Date Picker ==== */}
        <DatePickerPopup
          visible={showPicker}
          onClose={() => setShowPicker(false)}
          onConfirm={handleConfirmDate}
        />
      </div>
    </div>
  );
};

export default WithdrawRecord;
